<template>
  <div id="AdvancedOptions" ref="container">
    <div class="content_area">
      <div class="form_wrap">
        <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text">上传人物图片</div>
          </div>
          <div class="Reference_image" v-loading="upmjloading"
               element-loading-background="rgba(122, 122, 122, 0.8)">
            <el-upload
                class="upload-demo"
                drag
                :action="fileApi+'/api/front/upload/?fdir=mj_tool'"
                :show-file-list="false"
                accept="image/jpeg, image/png, image/bmp"
                :on-success="UpdataSuccess"
                :before-upload="beforeUpload"
                multiple>
              <div v-if="form.data.iw_url" class="yesUpload">
                <img :src="form.data.iw_url" alt="" class="yesUpload_img">
                <div class="yesUpload_icon" @click.stop="form.data.iw_url=''">
                  <i class="el-icon-delete"></i>
                </div>
              </div>
              <div v-else class="noUpload">
                <i style="font-size: 25px;font-weight: 700;color: #c0c4cc;" class="el-icon-plus"></i>
                <div style="margin: 5px 0"> 将图片拖到此处，或<span style=" color:#5865f2;">点击上传</span></div>
                <div> 只能上传jpg/png文件，且不超过8MB</div>
              </div>
            </el-upload>
          </div>
        </div>
        <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text">高级参数</div>
          </div>
          <div class="parameter">
            <div class="parameter_title">
              滤镜系数
            </div>
            <div class="parameter_slider">
              <div class="slider">
                <el-slider :min="0" :max="1" :step="0.1" v-model="form.data.strength"></el-slider>
              </div>
            </div>
          </div>
        </div>
        <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text">风格选择</div>
          </div>
          <div class="toolsModelList">
            <div class="music_style">
                <span :class="clickImgStyle.sign===item.sign?'spanColor':''"
                      v-for="item in musicStyle"
                      @click="clickLoraStyleList(item)">
                  {{ item.style }}
                </span>
            </div>
            <!--              <div class="music_styleImg" :style="{height:expand?270+'px':'auto'}">-->
            <div class="music_styleImg" :style="{height:clickImgStyle.shou?expand?270+'px':'auto':'auto'}">
              <div @click="listClick(item,'list1')"
                   :class="clickImgStyle.num===item.num? 'item_click':'styleImg_item'"
                   v-for="item in clickImgStyleList" v-if="item.sign.includes(clickImgStyle.sign) ">
                <img alt="" :src="item.src">
                <div>
                  {{ item.title }}
                </div>
              </div>
            </div>
            <div class="upDown" @click="expand=!expand" v-if="clickImgStyle.shou">
              <img v-if="expand" alt="" src='../img/down2.png' height="14" width="15"/>
              <img v-if="!expand" alt="" src="../img/upward.png" height="13" width="14"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom_area" flex-center>
      <div class="primary_button" @click="sendMsg" v-loading="sending">提交任务 <span>（消耗2积分）</span></div>
    </div>

    <faceVerifyPopup ref="faceVerifyPopup"></faceVerifyPopup>
  </div>
</template>

<script>
import faceVerifyPopup from "COMPONENTS/FaceVerifyPopu.vue";
import utils from '@/utils/index.js'
export default {
  components: {faceVerifyPopup},
  props: ['sampleList'],
  data() {
    return {
      sending: false,
      upload_img_url: "",
      form: {
        data: {
          iw_url: '',
          resource_type: '10001', //
          strength: 0.5, //美颜程序 0-1 浮点数
        },
        mj_tool: '',
      },
      fileApi: FILE_API_SERVER,
      isWxEnv: false,

      arrange: '',
      relation: '',
      toolList: [
        {
          title: '图片编辑', list: [
            {
              id: 1,
              relation: 0,
              name: '极速高清无损放大',
              guide: '无损放大图片，支持2倍、3倍、4倍放大，有效改善放大后图像的噪点与锯齿问题。',
              img: require('../img/magnify.png'),
              title: '无损放大',
              mj_tool: 'Upscaler',
            },

            {
              id: 2,
              relation: 0,
              name: '黑白图像上色',
              guide: '通过人工智能算法，识别黑白图像内容并填充色彩，使黑白图像变得鲜活。',
              img: require('../img/colour.png'),
              title: '黑白上色',
              mj_tool: 'Colorize',
            },
            {
              id: 3,
              relation: 0,
              name: '图像清晰度增强',
              guide: '利用Ai技术，智能识别图像主体以消除模糊，增强对比度和颜色，获得更清晰、更生动的视觉效果。',
              img: require('../img/repair.png'),
              title: '清晰增强',
              mj_tool: 'SharpnessEnhancement',
            },
            {
              id: 4,
              relation: 0,
              name: '图像风格转换',
              guide: '您可以将图像转换为卡通、铅笔、彩色铅笔或哥特式油画等多种风格。',
              img: require('../img/cartoon.png'),
              title: '风格转换',
              mj_tool: 'Painting',

            },

          ],
        },
        {
          title: '电商设计', list: [
            {
              id: 1,
              relation: 1,
              name: '背景移除',
              guide: '智能地识别图像的主体，将其视为前景并自动去除背景。适用于各种场景中的人物、动物等。',
              img: require('../img/capture.png'),
              title: '背景移除',
              mj_tool: 'BackgroundRemoval',
            },

          ],
        },
        {
          title: '创意应用', id: 3, list: [
            {
              id: 1,
              relation: 2,
              name: '头像提取',
              guide: '它能够准确检测头部区域，一键裁剪并去除其他元素。',
              img: require('../img/expansion.png'),
              title: '头像提取',
              mj_tool: 'HeadExtraction',

            },

          ],
        },
        {
          title: 'AI变美', relation: 3, list: [
            {
              id: 1,
              relation: 3,
              name: '照片一键美颜',
              title: '照片一键美颜',
              mj_tool: 'oneClickBeautyTransformation',
              guide: '利用AI技术，实现完整的肖像增强，包括皮肤平滑、美白、脸部瘦身等，以达到自然的外观',
              img: require('../img/beautify1.webp'),
              points: 1,
            },
            {
              id: 2,
              relation: 3,
              name: '人物动漫化',
              title: '人物动漫化',
              mj_tool: 'characterAnime',
              guide: '利用先进的AI技术将完整图像或照片转化为卡通或动漫效果，非常适合创建卡通化照片和卡通风格的虚拟形象',
              img: require('../img/beautify2.webp'),
              points: 1,
            },
            {
              id: 3,
              relation: 3,
              name: '人脸滤镜',
              title: '人脸滤镜',
              mj_tool: 'emitFacefilter',
              guide: '智能识别图像内容，快速应用AI滤镜，提升图像质感，支持滤镜强度调节，轻松优化视觉效果',
              img: require('../img/beautify3.webp'),
              points: 1,
            },
            {
              id: 4,
              relation: 3,
              name: '人脸模糊(打码)',
              title: '人脸模糊(打码)',
              mj_tool: 'emitBlurredfaces',
              guide: '利用先进的AI技术，智能识别人脸区域，一键模糊人脸，轻松保护隐私，提升图像安全性',
              img: require('../img/beautify4.webp'),
              points: 1,
            },
            {
              id: 5,
              relation: 3,
              name: '发型编辑',
              title: '发型编辑',
              mj_tool: 'emitHairstyleeditor',
              guide: '能够精准识别人像区域，实现一键更换发型和发色。您可以选择多达数十种发型和发色组合，轻松打造您独特的个性化造型，满足不同的美发需求',
              img: require('../img/beautify5.webp'),
              points: 1,
            },
            {
              id: 6,
              relation: 3,
              name: '表情编辑',
              title: '表情编辑',
              mj_tool: 'emitEmotioneditor',
              guide: '无论是闭嘴微笑、露齿笑、嘟嘴、还是耍酷或悲伤等十多种表情，您都可以轻松生成自然逼真的效果',
              img: require('../img/beautify6.webp'),
              points: 1,
            },
            {
              id: 7,
              relation: 3,
              name: '年龄・性別变换',
              title: '年龄・性別变换',
              mj_tool: 'emitFaceattributeediting',
              guide: '采用先进的AI技术，智能识别人脸，实现从15岁到85岁的年龄变换，以及男性与女性之间的性别转换',
              img: require('../img/beautify7.webp'),
              points: 1,
            },
            // {
            //   id: 8,
            //   relation: 3,
            //   name: '人脸美颜',
            //   title: '人脸美颜',
            //   mj_tool: 'emitFacebeauty',
            //   guide: '拥有美白和光滑皮肤等美化特性，以及面部塑形。此外，它还提供了多种滤镜，以增强您的图像并增添艺术气息。',
            //   img: require('../img/beautify8.webp'),
            //   points: 1,
            // },
            {
              id: 9,
              relation: 3,
              name: '人脸美妆',
              title: '人脸美妆',
              mj_tool: 'emitFacemakeup',
              guide: '它能够模拟逼真的化妆效果，并通过添加口红、高光、全套妆容以及其他化妆材料来进一步增强面部美化效果。',
              img: require('../img/beautify9.webp'),
              points: 1,
            },
            {
              id: 10,
              relation: 3,
              name: '唇色变换器',
              title: '唇色变换器',
              mj_tool: 'emitLipscolorchanger',
              guide: '它能够模拟逼真的化妆效果，并通过添加口红、高光、全套妆容以及其他化妆材料来进一步增强面部美化效果。',
              img: require('../img/beautify10.webp'),
              points: 1,
            },
            {
              id: 11,
              relation: 3,
              name: '人脸修复增强',
              title: '人脸修复增强',
              mj_tool: 'emitEnhanceface',
              guide: '自动去除图像中的模糊部分，提升脸部的清晰度和细节。通过AI处理，您可以轻松优化面部图像的质量，使其更加清晰、自然',
              img: require('../img/beautify11.webp'),
              points: 1,
            },
          ],
        },

      ],

      upmjloading: false,
      expand: true,
      clickImgStyle: {num: 1, sign: 1, shou: false,},
      clickImgStyleList: [
        {
          num: 1,
          type: '10001',
          sign: [1],
          title: '白茶',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/1.webp'),
        },
        {
          num: 2,
          type: '10002',
          sign: [1],
          title: '白皙',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/2.webp'),
        },
        {
          num: 3,
          type: '10003',
          sign: [1],
          title: '初夏',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/3.webp'),
        },
        {
          num: 4,
          type: '10004',
          sign: [1],
          title: '东京',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/4.webp'),
        },
        {
          num: 5,
          type: '10005',
          sign: [1],
          title: '告白',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/5.webp'),
        },
        {
          num: 6,
          type: '10006',
          sign: [1],
          title: '阳光',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/6.webp'),
        },
        {
          num: 7,
          type: '10007',
          sign: [1],
          title: '玫瑰',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/7.webp'),
        },

        {
          num: 8,
          type: '10008',
          sign: [2],
          title: '清晰',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/8.webp'),
        },
        {
          num: 9,
          type: '10009',
          sign: [2],
          title: '水晶',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/9.webp'),
        },
        {
          num: 10,
          type: '10010',
          sign: [2],
          title: '薄荷',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/10.webp'),
        },
        {
          num: 11,
          type: '10011',
          sign: [2],
          title: '基础',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/11.webp'),
        },
        {
          num: 12,
          type: '10012',
          sign: [2],
          title: '心动',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/12.webp'),
        },

        {
          num: 13,
          type: '10013',
          sign: [3],
          title: '哑灰',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/13.webp'),
        },
        {
          num: 14,
          type: '10014',
          sign: [3],
          title: '樱桃布丁',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/14.webp'),
        },
        {
          num: 15,
          type: '10015',
          sign: [3],
          title: '自然',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/15.webp'),
        },
        {
          num: 16,
          type: '10016',
          sign: [3],
          title: '优雅',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/16.webp'),
        },
        {
          num: 17,
          type: '10017',
          sign: [3],
          title: '黑白',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/17.webp'),
        },
        {
          num: 18,
          type: '10018',
          sign: [3],
          title: '水果',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/18.webp'),
        },
        {
          num: 19,
          type: '10019',
          sign: [3],
          title: '爱情',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/19.webp'),
        },
        {
          num: 20,
          type: '10020',
          sign: [3],
          title: '冬天',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/20.webp'),
        },
        {
          num: 21,
          type: '10021',
          sign: [3],
          title: '照片',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/21.webp'),
        },
        {
          num: 22,
          type: '10022',
          sign: [4],
          title: '夏天',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/22.webp'),
        },
        {
          num: 23,
          type: '10023',
          sign: [4],
          title: '芬芳',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/23.webp'),
        },
        {
          num: 24,
          type: '10024',
          sign: [4],
          title: '魅力',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/24.webp'),
        },
        {
          num: 25,
          type: '10025',
          sign: [4],
          title: '悸动',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/25.webp'),
        },
        {
          num: 26,
          type: '10026',
          sign: [4],
          title: '海滩',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/26.webp'),
        },
        {
          num: 27,
          type: '10027',
          sign: [4],
          title: '街拍',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/27.webp'),
        },
        {
          num: 28,
          type: '10028',
          sign: [4],
          title: '甜蜜',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/28.webp'),
        },
        {
          num: 29,
          type: '10029',
          sign: [4],
          title: '初吻',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/29.webp'),
        },
        {
          num: 30,
          type: '10030',
          sign: [4],
          title: '午后',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/30.webp'),
        },
        {
          num: 31,
          type: '10031',
          sign: [4],
          title: '活力',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/31.webp'),
        },
        {
          num: 32,
          type: '10032',
          sign: [4],
          title: '朦胧',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/32.webp'),
        },
        {
          num: 33,
          type: '10033',
          sign: [4],
          title: '快乐',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/33.webp'),
        },
        {
          num: 34,
          type: '10034',
          sign: [4],
          title: '时尚',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/34.webp'),
        },
        {
          num: 35,
          type: '10035',
          sign: [5],
          title: '泡沫',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/35.webp'),
        },
        {
          num: 36,
          type: '10036',
          sign: [5],
          title: '柠檬',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/36.webp'),
        },
        {
          num: 37,
          type: '10037',
          sign: [5],
          title: '棉花糖',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/37.webp'),
        },
        {
          num: 38,
          type: '10038',
          sign: [5],
          title: '溪流',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/38.webp'),
        },
        {
          num: 39,
          type: '10039',
          sign: [5],
          title: '美丽',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/39.webp'),
        },
        {
          num: 40,
          type: '10040',
          sign: [5],
          title: '咖啡',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/40.webp'),
        },
        {
          num: 41,
          type: '10041',
          sign: [5],
          title: '温柔',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/41.webp'),
        },
        {
          num: 42,
          type: '10042',
          sign: [5],
          title: '激情',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/42.webp'),
        },
        {
          num: 43,
          type: '10043',
          sign: [5],
          title: '温暖',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/43.webp'),
        },
        {
          num: 44,
          type: '10044',
          sign: [5],
          title: '早餐',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/44.webp'),
        },
        {
          num: 45,
          type: '10045',
          sign: [5],
          title: '清茶',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/45.webp'),
        },
        {
          num: 46,
          type: '10046',
          sign: [5],
          title: '晴朗',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/46.webp'),
        },

        {
          num: 47,
          type: '10047',
          sign: [6],
          title: '圣洁',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/47.webp'),
        },
        {
          num: 48,
          type: '10048',
          sign: [6],
          title: '森林',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/48.webp'),
        },
        {
          num: 49,
          type: '10049',
          sign: [6],
          title: '冲浪',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/49.webp'),
        },
        {
          num: 50,
          type: '10050',
          sign: [6],
          title: '牛奶咖啡',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/50.webp'),
        },
        {
          num: 51,
          type: '10051',
          sign: [6],
          title: '清晰的',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/51.webp'),
        },

        {
          num: 52,
          type: '10052',
          sign: [6],
          title: '微风',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/52.webp'),
        },
        {
          num: 53,
          type: '10053',
          sign: [6],
          title: '日落',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/53.webp'),
        },
        {
          num: 54,
          type: '10054',
          sign: [6],
          title: '鲜艳',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/54.webp'),
        },
        {
          num: 55,
          type: '10055',
          sign: [6],
          title: '日式',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/55.webp'),
        },

        {
          num: 56,
          type: '10056',
          sign: [6],
          title: '星光',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/56.webp'),
        },
        {
          num: 57,
          type: '10057',
          sign: [6],
          title: '阳光',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/57.webp'),
        },
        {
          num: 58,
          type: '10058',
          sign: [6],
          title: '落叶',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/58.webp'),
        },
        {
          num: 59,
          type: '10059',
          sign: [6],
          title: '活力',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/59.webp'),
        },
        {
          num: 60,
          type: '10060',
          sign: [6],
          title: '恋人',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/60.webp'),
        },
        {
          num: 61,
          type: '10061',
          sign: [6],
          title: '典雅',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/61.webp'),
        },

        {
          num: 62,
          type: '10062',
          sign: [7],
          title: '春天',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/62.webp'),
        },
        {
          num: 63,
          type: '10063',
          sign: [7],
          title: '罗马',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/63.webp'),
        },
        {
          num: 64,
          type: '10064',
          sign: [7],
          title: '绿色',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/64.webp'),
        },
        {
          num: 65,
          type: '10065',
          sign: [7],
          title: '微风',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/65.webp'),
        },

        {
          num: 66,
          type: '10066',
          sign: [7],
          title: '暖心',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/66.webp'),
        },
        {
          num: 67,
          type: '10067',
          sign: [7],
          title: '海水',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/67.webp'),
        },
        {
          num: 68,
          type: '10068',
          sign: [7],
          title: '神秘',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/68.webp'),
        },
        {
          num: 69,
          type: '10069',
          sign: [7],
          title: '典型1',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/69.webp'),
        },
        {
          num: 70,
          type: '10070',
          sign: [7],
          title: '典型2',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/70.webp'),
        },

        {
          num: 71,
          type: '10071',
          sign: [7],
          title: '雪白',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/71.webp'),
        },
        {
          num: 72,
          type: '10072',
          sign: [7],
          title: '阳光',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/72.webp'),
        },
        {
          num: 73,
          type: '10073',
          sign: [7],
          title: '浮云',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/73.webp'),
        },
        {
          num: 74,
          type: '10074',
          sign: [7],
          title: '流丽',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/74.webp'),
        },
        {
          num: 75,
          type: '10075',
          sign: [7],
          title: '电影',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/75.webp'),
        },
        {
          num: 76,
          type: '10076',
          sign: [7],
          title: '怀旧',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/76.webp'),
        },
        {
          num: 77,
          type: '10077',
          sign: [7],
          title: '奶酪',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/77.webp'),
        },
        {
          num: 78,
          type: '10078',
          sign: [7],
          title: '蝴蝶',
          select: false,
          scale: 0.8,
          src: require('../img/EmitFacefilter/78.webp'),
        },
      ],
      musicStyle: [
        {style: '滤镜一', sign: 1, num: 1, shou: false, resource_type: '10001',},
        {style: '滤镜二', sign: 2, num: 8, shou: false, resource_type: '10008',},
        {style: '滤镜三', sign: 3, num: 13, shou: false, resource_type: '10013',},
        {style: '滤镜四', sign: 4, num: 22, shou: false, resource_type: '10022',},
        {style: '滤镜五', sign: 5, num: 35, shou: false, resource_type: '10035',},
        {style: '滤镜六', sign: 6, num: 47, shou: false, resource_type: '10047',},
        {style: '滤镜七', sign: 7, num: 62, shou: false, resource_type: '10062',},
      ],
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    tips_list() {
      return this.sampleList.slice(this.sampleList.length - 20, this.sampleList.length)
    }
  },
  created() {
    this.arrange = this.$route.query.arrange
    this.relation = this.$route.query.relation
    this.form.mj_tool = this.toolList[this.relation].list[this.arrange - 1].mj_tool
    var ua = navigator.userAgent.toLowerCase();
    if ((ua.match(/MicroMessenger/i) == "micromessenger")) {
      this.isWxEnv = true
    } else {
      this.isWxEnv = false
    }
    this.initData()
  },
  mounted() {
    setTimeout(() => {
      document.addEventListener('click', this.handleDocumentClick);
      let _form = this.getCache("formAdvanceParams") || ""
      if (_form) {
        this.form = JSON.parse(_form)
      }
    }, 100)
  },
  methods: {
    listClick(item) {
      console.log('listClick',item)
      this.clickImgStyle.num = item.num
      this.form.data.resource_type=item.type
    },
    clickLoraStyleList(item, modle) {
      console.log('clickLoraStyleList',item)

      this.clickImgStyle.sign = item.sign
      this.clickImgStyle.num = item.num
      this.clickImgStyle.shou = item.shou
      this.form.data.resource_type=item.resource_type
    },
    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning',
          customClass: 'confirm_box'
        }).then(() => {
          this.$store.commit('setUserInfo', null)
          this.$store.commit('setIsLogin', false)

          if (this.isWxEnv) {
            // 微信环境内
            window.location.href = `${API_SERVER}/api/wx/oauth/?appid=${APP_ID}`
          } else {
            this.$store.commit('setShowLogin', true)
          }
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }

    },

    initData() {
      this.setCache("formAdvanceParams", JSON.stringify(this.form), 60 * 60 * 1000)
    },

    handleDocumentClick(event) {
      // 判断点击的区域是否是 container 元素或其子元素
      if (this.$refs.container && !this.$refs.container.contains(event.target)) {
        // 点击了除 container 以外的区域，执行相应操作
        this.setCache("formAdvanceParams", JSON.stringify(this.form), 60 * 60 * 1000)
      }
    },
    getProfile() {
      this.$http.get(`${MAIN_URLROOT}/api/front/user/profile/`).then(res => {
        if (res.status == '200') {
          this.$store.commit('setUserInfo', res.data)
          this.$store.commit('setIsLogin', true)
        }
      }).finally(() => {
      })
    },
    //发送消息
    sendMsg() {
      console.log(this.form)
      if (!this.checkLogin()) return
      if(!utils.setOptData(this.userInfo,'btn_aitool_create')){
          return
      }
      if (this.sending) {
        this.$message.warning('请等待上次绘图完成')
        return
      }
      if (this.form.data.iw_url === '') {
        this.$message.warning('请上传图片')
        return
      }

      // return;
      // 同步请求
      this.submitQuestion(this.form);
    },
    submitQuestion(data, parent_msg_code, i) {
      this.sending = true;
      // 提交问题
      data.source = "pc";
      this.$http.post('/front/aimj/mjtools/', data).then((res) => {
        if (res.status == 200) {
          this.$message({
            message: '创建任务成功！',
            type: 'success'
          });
          this.getProfile()
          this.$emit('submitForm', {})
        } else {
          let message = res.message;
          if (message == "vip_expire") {
            // VIP 过期了
            this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              console.log('进入会员中心')
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_open_vip") {
            // 未开通 VIP
            this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_gift_score") {
            // 积分不足
            this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "upgradevip") {
            // 队列已满
            this.$confirm(res.data.msg, '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/mjmember')
            }).catch(() => {

            });
            return
          } else if (message == "no_face_verify") {
            // 实名认证
            this.$refs.faceVerifyPopup.show()
            return
          }
          if (message.indexOf("您提问的内容包含违禁词") > -1) {
            message = "内容可能违反国家政策，请重新输入";
          }
          this.$confirm(message, '提示', {
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
          })
        }
      }).finally(() => {
        this.sending = false;
      })
    },
    // 上传图片
    UpdataSuccess(res, file) {
      this.upmjloading = false
      if (res.data.error !== '') {
        this.$message.error(res.data.error)
        return
      }
      this.form.data.iw_url = res.data.file_full_url;
    },
    beforeUpload(file) {
      if (!this.checkLogin()) {
        return false
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/member')
        })
        return false
      }
      const isLt3M = file.size / 1024 / 1024 < 3;
      const isValidType = ['image/jpeg', 'image/png', 'image/bmp'].includes(file.type);

      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          const { width, height } = img;
          // const isValidResolution =  width <= 4096 &&  height <= 4096;
          const isValidResolution = width >= 10 && width <= 2000 && height >= 10 && height <= 2000;

          if (!isValidType) {
            this.$message.error('只能上传 JPG/JPEG/PNG/BMP 格式的文件!');
            reject({ isValidType: false });
            return
          }

          if (!isLt3M) {
            this.$message.error('上传文件大小不能超过 3MB!');
            reject({ isLt3M: false });
            return
          }

          if (!isValidResolution) {
            // this.$message.error('图片分辨率需小于 4096x4096 像素!');
            this.$message.error('图片分辨率需大于 10x10 像素且小于 2000x2000 像素!');
            reject({ isValidResolution: false });
            return
          }

          resolve({ isValidType, isLt3M, isValidResolution, });
        };
        img.onerror = () => {
          this.$message.error('无法读取图片分辨率，请检查图片是否损坏！');
          reject({ isImageValid: false });
        };
        this.upmjloading = true
      });
    },
  },

}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>


#AdvancedOptions {
  display: flex;
  height: 100%;
  flex-direction: column;
  color: #fff;
  background-color: #2b2d31;

  .content_area {
    flex: 1 1 0%;
    margin-bottom: 80px;

    .form_wrap {
      padding: 5px 15px 15px;
      height: 100%;
    }

    .options_item {
      margin: 10px 0 10px;

      .item_title {
        margin-bottom: 10px;

        .text {
          position: relative;
          padding-left: 10px;
          white-space: normal;
          display: flex;
          align-items: center;
          &:before {
            content: "";
            width: 4px;
            height: 15px;
            background: #5865f2;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            border-radius: 4px;
          }

          .icon {
            font-size: 15px;
            margin: 0 0 -2px 10px;
            color: #4a4c52;
            font-weight: bold;
          }
        }
      }

      // 上传参考图
      .Reference_image {
        width: 100%;
        height: 140px;
        overflow: hidden;
        box-sizing: border-box;

        .upload-demo {
          width: 100%;
          height: 100%;
        }

        /deep/ .el-upload-dragger {
          width: 100%;
          background-color: #1d2027;
          border-color: #3e4149;
          height: 140px;
        }

        /deep/ .el-upload-dragger:hover {
          border-color: #5865f2;
          height: 140px;
        }

        /deep/ .el-upload {
          width: 100%;
        }

        .noUpload {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #606266;
        }

        .yesUpload {
          position: relative;

          .yesUpload_img {
            height: 140px;
          }

          .yesUpload_icon {
            position: absolute;
            right: 8px;
            bottom: 12px;
            //background-color: aquamarine;
            color: #c1bfbb;
            font-size: 25px;
          }


        }
      }

      .parameter {
        width: 100%;
        padding: 15px 15px;
        border-radius: 6px;
        background-color: #1d2027;
        font-size: 14px;
        overflow: hidden;

        .parameter_title {
          margin: 0 0 5px 0;
        }

        .parameter_slider {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .slider_num {
            width: 40px;
            height: 28px;
            background-color: #2d313b;
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;

          }

          .slider {
            flex: 1;
            margin: 0 0 0 10px;

            /deep/ .el-slider__bar {
              background-color: #5865f2;
            }

            /deep/ .el-slider__button {
              border-color: #FFF;
              cursor: grab;
            }
          }
        }

        .Negative_Prom {
          .Negative_text {
            width: 100%;
            height: 50px;
            background-color: #313338;
            border: 2px solid #393c43;
            color: #c7d2c9;
            padding: 5px 5px;
            font-size: 14px;
            border-radius: 4px;
          }

          textarea::placeholder {
            color: #a8abb2; /* 将颜色改为灰色 */
          }

        }
      }

      .toolsModelList {

        .music_style {
          overflow-x: auto;
          width: 100%;
          white-space: nowrap;
          padding: 0 0 5px 0;

          span {
            font-size: 14px;
            margin-right: 15px;
            cursor: pointer;

          }

          .spanColor {
            color: #5865f2;
          }
        }

        .music_styleImg {
          padding: 0 0 0 0;
          display: flex;
          flex-wrap: wrap;
          //justify-content: space-between;
          gap: 3% 10px;
          //height: 270px;
          overflow: hidden;

          .styleImg_item {
            width: 31%;
            height: auto;
            //height: 83px;
            position: relative;
            border: 2px solid #5865f200;
            border-radius: 5px;
            overflow: hidden;
            margin: 2px 0;
            cursor: pointer;

            img {
              width: 100%;
              height: 100%;
            }

            div {
              width: 100%;
              padding: 2px 0;
              text-align: center;
              font-size: 12px;
              background-color: #000000ac;
              position: absolute;
              left: 0;
              bottom: 0;

            }

          }

          .item_click {
            border: 2px solid #5865f2;
            width: 31%;
            height: auto;
            position: relative;
            border-radius: 5px;
            margin: 2px 0;
            cursor: pointer;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
            }

            div {
              width: 100%;
              padding: 2px 0;
              text-align: center;
              font-size: 12px;
              background-color: #000000ac;
              position: absolute;
              left: 0;
              bottom: 0;
            }
          }
        }

        .upDown {
          background-color: #1e1f22;
          padding: 5px 0;
          display: flex;
          cursor: pointer;

          img {
            margin: 0 auto;
          }
        }

      }
    }
  }


  .bottom_area {
    position: fixed;
    bottom: 60px;
    left: 0;

    background-color: #2b2d31;
    height: 70px;
    width: 100%;
    padding: 0 30px;


    .primary_button {
      font-size: 16px;
      height: 46px;
      padding-top: 13px;
      padding-bottom: 13px;
      border-radius: 9999px;
      flex: 1 1 0%;

      span {
        font-size: 12px;
      }
    }
  }
}


.model_list {
  display: flex;


  .model_item {
    border-radius: 6px;
    border: 2px solid #1d2027;
    position: relative;
    overflow: hidden;

    &.active {
      border-color: #5865f2;
    }

    img {
      border: none;
      width: 100%;
    }

    .model_title {
      position: absolute;
      width: 100%;
      background-color: rgba(0, 0, 0, 0.73);
      height: 25px;
      font-size: 12px;
      left: 0;
      bottom: 0;
    }
  }

  .quality {
    display: flex;
    color: #fff;
    font-size: 14px;

    .quality_btn {
      border: 2px solid #393c43;
      border-radius: 3px;
      background-color: #1d2027;
      padding: 10px 20px;
      margin: 0 20px 0 0;
      cursor: pointer;
      flex: 1;
    }

    .quality_btns {
      border: 2px solid #5865f2;
      border-radius: 3px;
      background-color: #303245;
      padding: 10px 20px;
      margin: 0 20px 0 0;
      cursor: pointer;
      flex: 1;

    }

  }

}


.popup {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1501;
  bottom: 0;
  left: 0;
  transition: all 0.3s;
  background: rgba(0, 0, 0, 0.8);
  overflow: auto;
  animation: fadeInSlowAni 0.3s 1;

  .centerPanel {
    position: fixed;
    z-index: 1501;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: transform 0.2s;
  }
}

/deep/ .el-loading-mask {
  background: none;
}
</style>